export const TasksDescriptions = {
    SECURITY_TASK: "Security Tasks",
    REMOVALS: "Removals",
    STATION_TEAMS: "Station teams",
    STATION_CONTRACTORS: "Station contractors", 
    STATION_OFFLINE_FORMS: "Station offline forms", 
    PC_TEAMS: "P&CTeams", 
    PC_CONTRACTORS: "P&Contractors", 
    PC_OFFLINE_FORMS: "P&COfflineForms", 
    NEW_STATION: "New Station", 
    HAZARDOUS_MATERIALS: "Hazardous Materials",
    ASSET_HEALTH: "Assets Health", 
    DISTRIBUTION_AUTOMATION: "Distribution Automation",
    DROP_IN_CONTROL: "Drop in Control" 
    };
export const DisabledTasks = {
    Tasks : {

          TASK139: { value: 139, description: TasksDescriptions.SECURITY_TASK },
          TASK145: { value: 145, description: TasksDescriptions.SECURITY_TASK },

          TASK248: { value: 248, description: TasksDescriptions.REMOVALS },

          TASK1: { value: 1, description: TasksDescriptions.STATION_TEAMS },
          TASK32: { value: 32, description: TasksDescriptions.STATION_TEAMS },
          TASK49: { value: 49, description: TasksDescriptions.STATION_TEAMS },
          TASK70: { value: 70, description: TasksDescriptions.STATION_TEAMS },
          TASK17: { value: 17, description: TasksDescriptions.STATION_TEAMS },
          TASK54: { value: 54, description: TasksDescriptions.STATION_TEAMS },
          TASK71: { value: 71, description: TasksDescriptions.STATION_TEAMS },
          TASK31: { value: 31, description: TasksDescriptions.STATION_TEAMS },
          TASK55: { value: 55, description: TasksDescriptions.STATION_TEAMS },
          TASK56: { value: 56, description: TasksDescriptions.STATION_TEAMS },
          TASK333: { value: 333, description: TasksDescriptions.STATION_TEAMS },
          TASK335: { value: 335, description: TasksDescriptions.STATION_TEAMS },
          TASK336: { value: 336, description: TasksDescriptions.STATION_TEAMS },
          TASK11: { value: 11, description: TasksDescriptions.STATION_TEAMS },
          TASK14: { value: 14, description: TasksDescriptions.STATION_TEAMS },
          TASK52: { value: 52, description: TasksDescriptions.STATION_TEAMS },
          TASK58: { value: 58, description: TasksDescriptions.STATION_TEAMS },
          TASK72: { value: 72, description: TasksDescriptions.STATION_TEAMS },
          TASK247: { value: 247, description: TasksDescriptions.STATION_TEAMS },

          TASK21: { value: 21, description: TasksDescriptions.STATION_CONTRACTORS },
          TASK59: { value: 59, description: TasksDescriptions.STATION_CONTRACTORS },
 
          TASK332: { value: 332, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK294: { value: 294, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK295: { value: 295, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK303: { value: 303, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK304: { value: 304, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK305: { value: 305, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK308: { value: 308, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK309: { value: 309, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK310: { value: 310, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK311: { value: 311, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK322: { value: 322, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK314: { value: 314, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK315: { value: 315, description: TasksDescriptions.STATION_OFFLINE_FORMS },
          TASK316: { value: 316, description: TasksDescriptions.STATION_OFFLINE_FORMS },
 
          TASK126: { value: 126, description: TasksDescriptions.PC_TEAMS },
          TASK148: { value: 148, description: TasksDescriptions.PC_TEAMS },
          TASK160: { value: 160, description: TasksDescriptions.PC_TEAMS },
          TASK161: { value: 161, description: TasksDescriptions.PC_TEAMS },
          TASK163: { value: 163, description: TasksDescriptions.PC_TEAMS },
          TASK170: { value: 170, description: TasksDescriptions.PC_TEAMS },
          TASK172: { value: 172, description: TasksDescriptions.PC_TEAMS },
          TASK173: { value: 173, description: TasksDescriptions.PC_TEAMS },
          TASK174: { value: 174, description: TasksDescriptions.PC_TEAMS },
          TASK177: { value: 177, description: TasksDescriptions.PC_TEAMS },
          TASK182: { value: 182, description: TasksDescriptions.PC_TEAMS },
          TASK188: { value: 188, description: TasksDescriptions.PC_TEAMS },
          TASK213: { value: 213, description: TasksDescriptions.PC_TEAMS },
          TASK218: { value: 218, description: TasksDescriptions.PC_TEAMS },
          TASK230: { value: 230, description: TasksDescriptions.PC_TEAMS },
          TASK238: { value: 238, description: TasksDescriptions.PC_TEAMS },
          TASK285: { value: 285, description: TasksDescriptions.PC_TEAMS },
          TASK337: { value: 337, description: TasksDescriptions.PC_TEAMS },

          TASK125: { value: 125, description: TasksDescriptions.PC_CONTRACTORS },
          TASK127: { value: 127, description: TasksDescriptions.PC_CONTRACTORS },
          TASK162: { value: 162, description: TasksDescriptions.PC_CONTRACTORS },

          TASK300: { value: 300, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK301: { value: 301, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK302: { value: 302, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK306: { value: 306, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK317: { value: 317, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK319: { value: 319, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK320: { value: 320, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK331: { value: 331, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK334: { value: 334, description: TasksDescriptions.PC_OFFLINE_FORMS },
          TASK366: { value: 366, description: TasksDescriptions.PC_OFFLINE_FORMS },
  
          TASK326: { value: 326, description: TasksDescriptions.NEW_STATION },
          TASK12: { value: 12, description: TasksDescriptions.NEW_STATION },
          TASK76: { value: 76, description: TasksDescriptions.NEW_STATION },
     
          TASK326: { value: 326, description: TasksDescriptions.HAZARDOUS_MATERIALS },
          TASK338: { value: 338, description: TasksDescriptions.HAZARDOUS_MATERIALS },
        
          TASK3: { value: 3, description: TasksDescriptions.ASSET_HEALTH },
          TASK18: { value: 18, description: TasksDescriptions.ASSET_HEALTH },
          TASK20: { value: 20, description: TasksDescriptions.ASSET_HEALTH },
          TASK40: { value: 40, description: TasksDescriptions.ASSET_HEALTH },
          TASK46: { value: 46, description: TasksDescriptions.ASSET_HEALTH },
          TASK47: { value: 47, description: TasksDescriptions.ASSET_HEALTH },
          TASK90: { value: 90, description: TasksDescriptions.ASSET_HEALTH },
        
          TASK42: { value: 42, description: TasksDescriptions.DISTRIBUTION_AUTOMATION },
          TASK43: { value: 43, description: TasksDescriptions.DISTRIBUTION_AUTOMATION },
          TASK44: { value: 44, description: TasksDescriptions.DISTRIBUTION_AUTOMATION },
          TASK45: { value: 45, description: TasksDescriptions.DISTRIBUTION_AUTOMATION },
          TASK189: { value: 189, description: TasksDescriptions.DISTRIBUTION_AUTOMATION },
          TASK190: { value: 190, description: TasksDescriptions.DISTRIBUTION_AUTOMATION },      
          TASK194: { value: 194, description: TasksDescriptions.DISTRIBUTION_AUTOMATION },
          TASK2: { value: 2, description: TasksDescriptions.DROP_IN_CONTROL },     
          TASK135: { value: 135, description: TasksDescriptions.DROP_IN_CONTROL },           
    },
   
    NoMotorOptions: {
      HOOK_STICK: "Hook Stick",
      LEVER: "Lever",
      GEAR: "Gear",
    },
   
    NoMotorTaskOptions: {
      TASK191: 191,
      TASK92: 92,
      TASK195: 195,
      TASK197: 197,
      TASK249: 249,
      TASK252: 252,
      TASK253: 253,
    },
   
    ProtectionDevicesTaskOptions: {
      TASK200: 200,
      TASK155: 155,
      TASK198: 198,
      TASK319: 319,
      TASK144: 144,
    },
  };

 export const HazardousValueOptions = [
    { value: "PCBs", label: "PCBs" },
    { value: "Asbestos", label: "Asbestos" },
    { value: "Oil", label: "Oil" },
    { value: "Arc By products", label: "Arc By products" },
    { value: "Other", label: "Other" },
  ];
   